import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { LoginComponent } from './pages/login/login.component';
import { DetailTransactionComponent } from './pages/detail-transaction/detail-transaction.component';
import { OrderDetailComponent } from './pages/order-detail/order-detail.component';
import { LayoutComponent } from './layout/layout.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'room/seg/:segment',
    component: DetailTransactionComponent
  },

  {
    path: 'feedback',
    title: 'Saran & Masukan | Fotokapsul',
    loadComponent: () =>
      import('./pages/feedback/feedback.component')
        .then(m => m.FeedbackComponent)
  },

  {
    path: 'r/:segment',
    component: OrderDetailComponent
  },
  {
    path: 'queue-monitoring1',
    loadComponent: () => import('./pages/queue-monitoring/queue-monitoring.component').then(m => m.QueueMonitoringComponent)
  },
  {
    path: 'queue-monitoring2',
    loadComponent: () => import('./pages/queue-monitoring2/queue-monitoring2.component').then(m => m.QueueMonitoring2Component)
  },
  {
    path: 'queue-monitoring',
    loadComponent: () => import('./pages/queue-monitoring/queue-monitoring.component').then(m => m.QueueMonitoringComponent)
  },
  {
    path: 'queue-join',
    loadComponent: () => import('./pages/queue-join/queue-join.component').then(m => m.QueueJoinComponent)
  },
  {
    path: 'review-monitoring',
    title: 'Monitoring Ulasan | Fotokapsul',
    loadComponent: () => import('./pages/review-monitoring/review-monitoring.component').then(m => m.ReviewMonitoringComponent)
  },
  {
    path: 'client-print',
    loadComponent: () => import('./pages/client-print/client-print.component').then(m => m.ClientPrintComponent)
  },
  {
    path: 'fotoinaja-dashboard',
    loadComponent: () => import('./pages/fotoinaja-dashboard/fotoinaja-dashboard.component').then(m => m.FotoinajaDashboardComponent)
  },
  {
    path: 'fotoinaja-dashboard/:segment',
    loadComponent: () => import('./pages/fotoinaja-dashboard/fotoinaja-dashboard.component').then(m => m.FotoinajaDashboardComponent)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'laporan-cc',
        loadComponent: () => import('./pages/laporan-cc/laporan-cc.component').then(m => m.LaporanCcComponent)
      },
      {
        path: 'dashboard-kapsul',
        canActivate: [roleGuard],
        data: { roles: ['company-owner-fotokapsul'] },
        loadComponent: () => import('./pages/dashboard-kapsul/dashboard-kapsul.component').then(m => m.DashboardKapsulComponent)
      },
      {
        path: 'companies',
        loadComponent: () => import('./pages/companies/companies.component').then(m => m.CompaniesComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/users/users.component').then(m => m.UsersComponent)
      },
      {
        path: 'roles',
        loadComponent: () => import('./pages/roles/roles.component').then(m => m.RolesComponent)
      },
      {
        path: 'permissions',
        loadComponent: () => import('./pages/permissions/permissions.component').then(m => m.PermissionsComponent)
      },
      {
        path: 'products',
        loadComponent: () => import('./pages/products/products.component').then(m => m.ProductsComponent)
      },
      {
        path: 'devices',
        loadComponent: () => import('./pages/devices/devices.component').then(m => m.DevicesComponent)
      },
      {
        path: 'orders',
        loadComponent: () => import('./pages/orders/orders.component').then(m => m.OrdersComponent)
      },
      {
        path: 'services',
        loadComponent: () => import('./pages/services/services.component').then(m => m.ServicesComponent)
      },
      {
        path: 'frames',
        loadComponent: () => import('./pages/frames/frames.component').then(m => m.FramesComponent)
      },
      {
        path: 'frames/add',
        loadComponent: () => import('./pages/frames/add-frame/add-frame.component').then(m => m.AddFrameComponent)
      },
      {
        path: 'frames/edit/:id',
        loadComponent: () => import('./pages/frames/add-frame/add-frame.component').then(m => m.AddFrameComponent)
      },
      {
        path: 'addons',
        loadComponent: () => import('./pages/addons/addons.component').then(m => m.AddonsComponent)
      },
      {
        path: 'order-services',
        loadComponent: () => import('./pages/order-services/order-services.component').then(m => m.OrderServicesComponent)
      },
      {
        path: 'order-addons',
        loadComponent: () => import('./pages/order-addons/order-addons.component').then(m => m.OrderAddonsComponent)
      },
      {
        path: 'photo-sessions',
        loadComponent: () => import('./pages/photo-sessions/photo-sessions.component').then(m => m.PhotoSessionsComponent)
      },
      {
        path: 'promos',
        loadComponent: () => import('./pages/promos/promos.component').then(m => m.PromosComponent)
      },
      {
        path: 'vouchers',
        loadComponent: () => import('./pages/vouchers/vouchers.component').then(m => m.VouchersComponent)
      },
      {
        path: 'ai-templates',
        loadComponent: () => import('./pages/ai-templates/ai-templates.component').then(m => m.AiTemplatesComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'my-balance',
        loadComponent: () => import('./pages/my-balance/my-balance.component').then(m => m.MyBalanceComponent)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
